export function transformToUpperSnakeCase(value: string): string {
  return value
    .replace(/[\s-]+/gu, '_') // Replace spaces or hyphens with underscores
    .replace(/(?<temp1>[A-Z])(?=[a-z])/gu, '_$1') // Add underscore before uppercase letters followed by lowercase letters
    .replace(/(?<temp2>[a-z\d])(?<temp1>[A-Z])/gu, '$1_$2') // Add underscore between lowercase/number and uppercase
    .toUpperCase() // Convert the entire string to uppercase
    .replace(/^_+/u, '') // Remove leading underscores
    .replace(/_+/gu, '_'); // Collapse multiple underscores into one
}
